module.exports = __webpack_public_path__ + "static/media/info-circle.ed9eff58.svg";